export { LegacyCollectionPageLayout } from './LegacyCollectionPageLayout';
